import { useCallback, type ImgHTMLAttributes } from "react";

type BlobImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & { blob: Blob; alt: string };

/** Картинка из локального файла: временная ссылка на него живёт, пока `<img>` в DOM, и отзывается при смене файла. */
export function BlobImage({ blob, alt, ...rest }: BlobImageProps) {
  const attach = useCallback(
    (image: HTMLImageElement | null) => {
      if (!image) return;
      const url = URL.createObjectURL(blob);
      image.src = url;
      return () => URL.revokeObjectURL(url);
    },
    [blob],
  );
  return <img {...rest} ref={attach} alt={alt} />;
}
